module.exports = __webpack_public_path__ + "static/media/about-us-header-artwork.def82ee9.svg";